import React from 'react';
export function Footer() {
  return <footer className="py-16 md:py-20 bg-obsidian border-t border-white/5" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6 md:px-8 text-center" data-id="element-34">
        <img src="https://cdn.magicpatterns.com/uploads/wi9wgmYeXMSb76H9MNpVfP/Red_Lounge_Logo.png" alt="Red Lounge Logo" className="h-16 w-16 md:h-20 md:w-20 mx-auto rounded-xl object-cover shadow-2xl border border-white/10 mb-12" data-id="element-35" />

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 md:gap-12 mb-16 text-xs md:text-sm uppercase tracking-[0.3em] font-sans text-white/60" data-id="element-36">
          <div data-id="element-37">
            <h4 className="text-white mb-4" data-id="element-38">Location</h4>
            <p data-id="element-39">1234 Crimson Way NW</p>
            <p data-id="element-40">Washington, DC 20001</p>
          </div>
          <div data-id="element-41">
            <h4 className="text-white mb-4" data-id="element-42">Hours</h4>
            <p data-id="element-43">Wed — Sat: 21:00 - 03:00</p>
            <p data-id="element-44">Sun: 20:00 - 02:00</p>
          </div>
          <div data-id="element-45">
            <h4 className="text-white mb-4" data-id="element-46">Contact</h4>
            <p data-id="element-47">concierge@redloungedc.com</p>
            <p data-id="element-48">+1 (202) 555-0123</p>
          </div>
        </div>

        <div className="pt-12 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-49">
          <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/40" data-id="element-50">
            © 2026 Red Lounge Bar. All Rights Reserved.
          </p>
          <div className="flex gap-8 text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/60" data-id="element-51">
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-52">
              Instagram
            </a>
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-53">
              Facebook
            </a>
            <a href="#" className="hover:text-champagne transition-colors" data-id="element-54">
              Privacy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}